import axios from '../config/axios.js';

class AuthService {
  userLogin = (loginData) => {
    return axios
      .post('/assistant-login', loginData)
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changePassword = (passwordData) => {
    return axios
      .post('/change-password', passwordData)
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  userLogout = () => {
    return axios
      .post('/logout', [])
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  createUser = (data) => {
    return axios
      .post('/user-register', data)
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
  resetPassword1 = (passwordData) => {
    return axios
      .post('/dsr-reset-password', passwordData)
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
  getProfile = async () => {
    try {
      const response = await axios.get('/get-profile');
      const { data: data_1 } = response;
      return data_1;
    } catch (error) {
      console.log(error);
    }
  };

  forgotPassword = async (forgotData) => {
    return axios
      .post('/forgot-password', forgotData)
      .then(function (response) {
        const { data } = response;
        console.log(data);
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
  verifyResetLink = (data) => {
    return axios
      .post('/verify-reset-link', data)
      .then(function (response) {
        const { data } = response;
        console.log(data);
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
  resetPassword = (forgotData) => {
    return axios
      .post('/reset-password', forgotData)
      .then(function (response) {
        const { data } = response;
        console.log(data);
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

    changePassword = (passwordData) => {
    return axios
      .post('/change-password', passwordData)
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };


}

export default new AuthService();
